// BackgroundSlider.js

import "./BackgroundSlider.css";
import imageSlide from "./images.js";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SLIDE_DURATION = 6000;

const BackgroundSlider = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const goToSlide = useCallback((index) => {
    setCurrentImage(index);
  }, []);

  // Advance on a timer, but hold while the visitor is hovering the hero.
  useEffect(() => {
    if (isPaused || imageSlide.length < 2) return;

    const timer = setTimeout(() => {
      setCurrentImage((index) => (index + 1) % imageSlide.length);
    }, SLIDE_DURATION);

    return () => clearTimeout(timer);
  }, [currentImage, isPaused]);

  return (
    <section
      className="hero"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="hero__media">
        {imageSlide.map((image, index) => (
          <div
            key={image.url}
            className={`hero__slide${
              index === currentImage ? " is-active" : ""
            }`}
            style={{ backgroundImage: `url(${image.url})` }}
          />
        ))}
        <div className="hero__scrim" />
      </div>

      <div className="hero__content">
        <h1 className="hero__title">AIM BLIND AND DRAPERY</h1>
        <p className="hero__subtitle">
          Discover The Benefits of Using Onsite Blind Repair
        </p>
        <Link to="/create-inquiry" className="hero__cta">
          Get Quote
        </Link>
      </div>

      <div className="hero__dots">
        {imageSlide.map((image, index) => (
          <button
            key={image.url}
            type="button"
            className={index === currentImage ? "is-active" : ""}
            aria-label={`Show image ${index + 1} of ${imageSlide.length}`}
            aria-current={index === currentImage}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default BackgroundSlider;
